import React from 'react';
import styles from './LegendsForApplicationMonitoring.module.scss';
import useRequestByHouse from '../../../../../../hooks/useRequestByHouse';
import FlatCountRequestView from '../FlatCountRequestView/FlatCountRequestView';
import RequestFlatCountView from '../RequestFlatCountView/RequestFlatCountView';
import FlatExcessCountView from '../FlatExcessCountView/FlatExcessCountView';
import { useSelector } from 'react-redux';
import FlatStagesCountView from '../FlatStagesCountView/FlatStagesCountView';

const LegendsForApplicationMonitoring = ({ gridData }) => {
  const { requests = [] } = useRequestByHouse();

  const monitoringStage = useSelector(
    (state) => state.housingStockStore.monitoringStage
  );

  return (
    <div className={styles.root}>
      <FlatCountRequestView requests={requests} />
      {/* <RequestFlatCountView requests={requests} /> */}
      <FlatExcessCountView requests={requests} />
      {monitoringStage !== 4 && <FlatStagesCountView gridData={gridData} />}
    </div>
  );
};

export default LegendsForApplicationMonitoring;
